import { render, staticRenderFns } from "./PrintBillOfLading.vue?vue&type=template&id=470ba803"
import script from "./PrintBillOfLading.vue?vue&type=script&lang=js"
export * from "./PrintBillOfLading.vue?vue&type=script&lang=js"
import style0 from "./PrintBillOfLading.vue?vue&type=style&index=0&id=470ba803&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports